
import SelectAbstract from "components/SelectAbstract";
import Button from "components/Button";

import { ReactComponent as DotsIcon } from 'icons/buttons/dots.svg';
import { ReactComponent as ArrowIcon } from 'icons/buttons/arrow.svg';
import { ReactComponent as EditIcon } from 'icons/buttons/edit.svg';
import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';
import { ReactComponent as PrintIcon } from 'icons/buttons/print.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as TrashIcon } from 'icons/components/trash.svg';
import { ReactComponent as UploadIcon } from 'icons/components/upload.svg';
import { ReactComponent as DownloadIcon } from 'icons/components/download.svg';
import { ReactComponent as SettingIcon } from 'icons/components/setting.svg';
import { ReactComponent as FilterIcon } from 'icons/components/filter.svg';

const map = {
    "dots": <DotsIcon />,
    "arrow": <ArrowIcon />,
    "arrowDown": <ArrowIcon className="rotate90" />,
    "arrowUp": <ArrowIcon className="rotate90m" />,
    "arrowLeft": <ArrowIcon className="rotate180" />,
    "edit": <EditIcon />,
    "plus": <PlusIcon />,
    "print": <PrintIcon />,
    "close": <CloseIcon />,
    "trash": <TrashIcon />,
    "upload": <UploadIcon />,
    "download": <DownloadIcon />,
    "setting": <SettingIcon />,
    "filter": <FilterIcon />,
};

export default class ButtonIcon extends SelectAbstract {
    render() {
        const { name, typeIcon } = this.props;
        const icon = map[name] || map["dots"];

        return (
            <Button
                className={name}
                type={typeIcon || "secondary"}
                size="small"
                {...this.props}
                icon={icon}
            />
        );
    }
}
